import PropTypes from 'prop-types';
import { memo } from 'react';
// -*- mode: jsx;-*-
import Html5Entities from '../../external/npm/html5-entities.js';
import { makeStillNeededWithMatch } from './projectUtils.js';


export let MatchOfferInfo = function ({ project, hideMatchOffer, mainMatch, fullyFunded, numDonors }) {
    function makeCompletedMatchingOrSignificantDonorInfo(donorSalutation) {
        let salutation = donorSalutation;
        if (salutation === 'Anonymous') {
            salutation = 'an anonymous donor';
        }

        let text = 'This classroom project was brought to life by ';
        text += salutation;
        if (numDonors > 2) {
            text += ' and ' + (numDonors - 1) + ' other donors';
        } else if (numDonors > 1) {
            text += ' and one other donor';
        }
        text += '.';

        return (
            <div className="match-offer-explanation">
                {Html5Entities.decode(text)}
            </div>
        );
    }

    function makeMatchingInfo(matching) {
        var salutation = matching.donorSalutation;
        if (salutation === 'Anonymous') {
            salutation = 'an anonymous donor';
        }

        let multiplier = '';
        switch (matching.multipleForDisplay) {
            case '2X':
                multiplier +=  'Double your impact!';
                break;
            case '3X':
                multiplier =  'Triple your impact!';
                break;
            default:
                multiplier =  matching.multipleForDisplay + ' your impact!';
        }

        var badgeClass = matching.multipleForDisplay === '1.5X'
            ? 'onepointfive' : 'DYI';

        var badgeContent = matching.multipleForDisplay;

        return (
            <div>
                <div className="match-offer-explanation">
                    <div className={'match-offer-badge ' + badgeClass}><span className="match-offer-badge-content">{badgeContent}</span></div>
                    <span className="desktop"><span className="multiplier">{Html5Entities.decode(multiplier)}</span> Thanks to {Html5Entities.decode(salutation)}.</span>
                    <span className="mobile"><strong><span>{makeStillNeededWithMatch(project)}</span></strong> for now, thanks to a match.</span>
                </div>
            </div>
        );
    }

    function fetchData() {
        let matchText = null;
        if (!hideMatchOffer) {
            let matching = project.matchingFund;
            const mainMatchingKey = (mainMatch || {}).matchingKey;
            if (matching && matching.type && (mainMatchingKey !== matching.matchingKey || isMobileView())) {
                matchText = makeMatchingInfo(matching);
            } else if (fullyFunded) {
                matching = project.completedMatching;
                if (matching && matching.type) {
                    matchText = makeCompletedMatchingOrSignificantDonorInfo(matching.donorSalutation);
                } else {
                    const sigFundingDonor = project.significantFundingDonor;
                    if (sigFundingDonor) {
                        var significantFundingDonorText = makeCompletedMatchingOrSignificantDonorInfo(sigFundingDonor.donorSalutation);
                    }
                }
            } else if(matching && matching.type) {
                matchText = 'Donations to this project are being matched!'; //Covering the edge case of selecting a specific match in search and no copy ends up showing on the matched card
            }
        }

        return [matchText, significantFundingDonorText];
    }

    const data = fetchData();
    const matchText = data[0];
    const significantFundingDonorText = data[1];

    return <div className="match-offer-section">{matchText}{significantFundingDonorText}</div>;
};

MatchOfferInfo.propTypes = {
    project: PropTypes.object.isRequired,
    mainMatch: PropTypes.object,
    fullyFunded: PropTypes.bool.isRequired,
    hideMatchOffer: PropTypes.bool,
    numDonors: PropTypes.number,
};

MatchOfferInfo = memo(MatchOfferInfo);
